<template>
  <v-card>
    <v-card-title>{{ shouldUpdate ? `Обновить кросс-сейл` : `Добавить кросс-сейл` }}</v-card-title>
    <v-card-text>
      <div v-if="!loadingDialog">
        <IngredientCell
          :item="selectedIngredient"
          @click="itemSelect"
        />
        <v-text-field
          v-model.number="priority"
          type="number"
          outlined
          hide-details
          dense
          label="Приоритет"
          class="mt-4"
        />

        <OneProductsSelector
          v-model="ingredientsSelectionDialog"
          @updateProductsData="updateProductsStructure($event)"
          :menu="productsStructure"
          :productsData="productsData"
          :selectedIngredients="selectedIngredients"
        />
      </div>
      <div
        v-else
        align="center"
      >
        <v-progress-circular
          size="20"
          width="2"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row
        class="ma-0"
        justify="center"
        no-gutters
      >
        <v-btn
          :color="'primary'"
          depressed
          @click="confirm"
          class="mr-3"
          :loading="loading"
          :disabled="!selectedIngredient"
          >{{ shouldUpdate ? 'Обновить' : 'Добавить' }}
        </v-btn>
        <v-btn
          v-if="shouldUpdate"
          class="white--text"
          depressed
          color="red"
          @click="removeDialog = true"
          :disabled="loading"
          >{{ 'Удалить' }}
        </v-btn>
        <v-btn
          depressed
          color=""
          @click="close"
          class="ml-3"
          :disabled="loading"
        >
          Отменить
        </v-btn>
      </v-row>
    </v-card-actions>
    <!-- Диалог удаления -->
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>Удалить</v-card-title>
        <v-card-text>Удалить выбранный кросс-сейл?</v-card-text>
        <v-card-actions>
          <v-btn
            v-if="shouldUpdate"
            class="white--text"
            depressed
            color="primary"
            @click="remove"
            >{{ 'Удалить' }}
          </v-btn>
          <v-btn
            depressed
            color=""
            @click="removeDialog = false"
            class="ml-3"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import OneProductsSelector from '@/admin/views/promocodes/coditionComoponents/oneProducts/OneProductsSelector.vue'
  import IngredientCell from './ingredientSelection/IngredientCell.vue'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'CrossSellDialogItem',
    components: { OneProductsSelector, IngredientCell },
    props: {
      selectedIngredients: [],
      item: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      shouldUpdate: false,
      crossSellItem: null,
      selectedIngredient: null,
      ingredientsSelectionDialog: false,
      removeDialog: false,
      priority: 100,
      productsStructure: [],
      productsData: [],
      loadingDialog: true
    }),
    computed: {
      currentSelectedItem() {
        return {
          ...this.selectedIngredient,
          priority: this.priority
        }
      }
    },
    methods: {
      itemSelect() {
        this.ingredientsSelectionDialog = true
      },
      select(value) {
        this.ingredientsSelectionDialog = false
        this.selectedIngredient = value
        this.updateProductsData()
      },
      clear() {
        this.selectedIngredient = null
        this.priority = 100
      },
      close() {
        this.clear()
        this.$emit('close')
      },
      remove() {
        this.removeDialog = false
        this.clear()
        this.$emit('remove')
      },
      confirm() {
        if (this.shouldUpdate) {
          this.$emit('update', this.currentSelectedItem)
        } else {
          this.$emit('added', this.currentSelectedItem)
        }

        this.clear()
      },
      updateProductsStructure(data) {
        this.select(data)
      },
      buildProductsStructure(data) {
        if (!data || !data.group_id || !data.product_id) {
          return [{ products: [] }]
        }

        return [
          {
            products: [
              {
                type: 'product_group',
                product_id: data.group_id,
                children: [
                  {
                    type: 'product',
                    product_id: data.product_id,
                    children: [
                      {
                        product_id: data.ingredient_id,
                        type: 'ingredient',
                        image: data.image || '',
                        name: data.name || '',
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },

      updateProductsData() {
        const currentItem = this.currentSelectedItem
        if (currentItem?.product_id != null) {
          const groupId = this.findGroupId(this.productsStructure, currentItem.product_id)

          const data = {
            ...cloneDeep(currentItem),
            group_id: groupId
          }
          this.productsData = this.buildProductsStructure(data)
        }
      },

      findGroupId(groups, targetId) {
        for (const group of groups) {
          const exist = group.items?.some(item => item.id === targetId)

          if (exist) {
            return group.id
          }
        }
        return null
      }
    },
    mounted() {
      void this.$product
        .sendGetSingle('structure', undefined, {
          active: true,
          show_in_app: true
        })
        .then(res => {
          this.productsStructure = res.result
          if (this.item != null) {
            this.selectedIngredient = this.item
            this.priority = this.item.priority
            this.shouldUpdate = true
            this.updateProductsData()
          }
        })
        .finally(_ => {
          this.loadingDialog = false
        })
    }
  }
</script>
